import React, { useState, createContext } from "react";
import SideBar from "../../components/SideBar";
import Inicio from "./mobile/Inicio";
import Pedidos from "./mobile/Pedidos";
import Catalogo from "./mobile/Catalogo";
import Clientes from "./mobile/Clientes";
import PerfilTienda from "./mobile/PerfilTienda";
import Billetera from "./mobile/Billetera";

export const MobileContext = createContext("MobileContext");

const Mobile = () => {
  const [sideBarOpen, setSideBarOpen] = useState(false);
  const [pedidosView, setPedidosView] = useState({ open: false, tipo: "" });
  const [catalogoOpen, setCatalogoOpen] = useState(false);
  const [clientesOpen, setClientesOpen] = useState(false);
  const [perfilTiendaOpen, setPerfilTiendaOpen] = useState(false);
  const [billeteraOpen, setBilleteraOpen] = useState(false);

  const context = {
    mobile: true,
    sideBarOpen,
    pedidosView,
    catalogoOpen,
    clientesOpen,
    perfilTiendaOpen,
    billeteraOpen,
    onOpenSideBar: () => setSideBarOpen(true),
    onCloseSideBar: () => setSideBarOpen(false),

    onOpenPedidos: tipo => {
      setSideBarOpen(false);
      setPedidosView({ open: true, tipo });
    },
    onClosePedidos: () => setPedidosView({ open: false, tipo: "" }),

    onOpenCatalogo: () => {
      setSideBarOpen(false);
      setCatalogoOpen(true);
    },
    onCloseCatalogo: () => setCatalogoOpen(false),

    onOpenClientes: () => {
      setSideBarOpen(false);
      setClientesOpen(true);
    },
    onCloseClientes: () => setClientesOpen(false),
    onOpenPerfilTienda: () => {
      setSideBarOpen(false);
      setPerfilTiendaOpen(true);
    },
    onClosePerfilTienda: () => setPerfilTiendaOpen(false),
    onOpenPerfilUsuario: () => {
      setSideBarOpen(false);
    },
    onOpenBilletera: () => {
      setSideBarOpen(false);
      setBilleteraOpen(true);
    },
    onCloseBilletera: () => setBilleteraOpen(false)
  };

  return (
    <MobileContext.Provider value={context}>
      <SideBar
        dense
        open={context.sideBarOpen}
        onClose={context.onCloseSideBar}
        onInicio={context.onCloseSideBar}
        onPedidosRecibidos={() => context.onOpenPedidos("recibidos")}
        onPedidosAbandonados={() => context.onOpenPedidos("abandonados")}
        onPedidosArchivados={() => context.onOpenPedidos("archivados")}
        onCatalogo={context.onOpenCatalogo}
        onClientes={context.onOpenClientes}
        onTienda={context.onOpenPerfilTienda}
        onUsuario={context.onOpenPerfilUsuario}
        onBilletera={context.onOpenBilletera}
      />

      <Inicio />
      <Pedidos />
      <Catalogo />
      <Clientes />
      <PerfilTienda />
      <Billetera />
    </MobileContext.Provider>
  );
};

export default Mobile;
